import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { produce } from 'immer'

import { GooglePost } from '@3m5/sm_publish-frontend-api'

import { ApiError } from '../networkContentRoot.reducer'
import { getGooglePageFeed } from './googleMyBusiness.actions'

export interface GoogleMyBusinessState {
  fetching: boolean
  googleFeeds?: GooglePost[]
  error: ApiError
}

const INITIAL_STATE: GoogleMyBusinessState = {
  fetching: false,
  error: {},
}

export const googleMyBusinessReducer = reducerWithInitialState(INITIAL_STATE)
  /**
   * getGooglePageFeed
   */
  .case(getGooglePageFeed.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.getGooglePageFeed
    })
  })

  .case(getGooglePageFeed.done, (state, { result }) => {
    return produce(state, draft => {
      draft.googleFeeds = result
      draft.fetching = false
    })
  })

  .case(getGooglePageFeed.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.getGooglePageFeed = (error as Response)
    })
  })
